import { Breadcrumb, Col, Row, Spin, Input, Select, message } from "antd";
import React, { FC, useEffect, useMemo, useState, useCallback } from "react";
import { useSelector, connect } from "react-redux";
import { bindActionCreators } from "redux";
import { mapCenters } from "../../constants/config";
import { getUserTenant, userRole } from "../../helpers/authStorage";
import { ALL_STATUSES } from "../../constants/query";
import { RootState } from "../../redux";
import { OrdersTable } from "./components/OrdersTable";
import useConfigureJobs from "./hooks/useConfigureJobs";
import { IConfigureModalInput } from "./types/configureModal.types";
import { actions as deliveryJobActions } from "../../redux/resources/deliveryJobs";
import { actions as adminOrdersActions } from "../../redux/resources/adminOrders";
import { actions as retailerJobActions } from "../../redux/resources/retailerJob";
import { actions as retailerOrdersActions } from "../../redux/resources/retailerOrders";
import { FormattedMessage } from "react-intl";
import { Link, useHistory, useParams } from "react-router-dom";
import { CustomCard } from "../../utils/common";
import "./styles/configureJobsModal.less";
import SingleJobHandler from "./components/SingleJobHandler";
import { Footer } from "antd/lib/layout/layout";
import PreviewOrdersAtion from "./components/PreviewOrdersAction";
import { IOrder } from "src/entities";
import { BASE_ROUTE } from "src/routes";

const JOB_MANAGEMENT_URL = userRole === "retailer" ? "/retailer_cabinet/jobs" : "/admin/jobs";
const JobsConfigurePage: FC<IConfigureModalInput & any> = ({
  // setConfigureModalOptions,
  freeOrders,
  getJobsByStatusAdminOrder,
  freeOrdersPagination,

  // actions
  fetchDeliveryJobs,
  getOneDeliveryJob,
  getPolylineDeliveryJob,
  getRoutesDeliveryJob,
  fetchAdminOrders,
  addOrdersDeliveryJob,
  removeOrdersDeliveryJob,
  moveOrdersDeliveryJob,
  configureJobDeliveryJob,
  setSelectedOrdersDeliveryJob,
  setPreviewOrdersDeliveryJob,
  resetConfigureJobDeliveryJob,
  changeOrderPositionDeliveryJob,
  changePickupPoistionDeliveryJob,
  resetFlagDeliveryJob,
  incompleteJobs,
}) => {
  const { id: jobId } = useParams<{ id?: string }>();
  const history = useHistory();
  const currentTenant = getUserTenant();
  const { Option } = Select;

  // ✅ Debug: Log component render
  console.log("🔵 JobsConfigurePage RENDERED");
  console.log("freeOrders prop:", freeOrders?.length || 0, "orders");

  const JobsToConfigure: {
    mainJob: {
      job: any;
      previewOrdersToAdd: IOrder[];
      selectedIds: number[];
    };
    compareToJob: {
      job: any;
      previewOrdersToAdd: IOrder[];
      selectedIds: number[];
    };
  } = useSelector((state: RootState) => {
    return userRole === "retailer" ? state?.retailerJob?.jobsToConfigure : state?.deliveryJobs?.jobsToConfigure;
  });

  // ✅ Filter postponed orders by date
  const filteredFreeOrders = useMemo(() => {
    console.log("\n=== FILTERING POSTPONED ORDERS ===");
    console.log("freeOrders from Redux:", freeOrders?.length || 0, "orders");

    if (!freeOrders || freeOrders.length === 0) {
      console.log("No free orders to filter");
      return freeOrders;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    console.log("Today date:", today);

    const filtered = freeOrders.filter((order: IOrder) => {
      // Show all 'new' orders
      if (order.status === "new") {
        console.log(`✅ Order ${order.id} (${order.status}): SHOW - new order`);
        return true;
      }

      // For postponed orders, check the date
      if (order.status === "postponed" || order.status === "postponed_after_pickup") {
        // Show if no postponed date
        if (!order.postponedTime || order.postponedTime === "") {
          console.log(`✅ Order ${order.id} (${order.status}): SHOW - no postponed date`);
          return true;
        }

        try {
          let postponedDate;

          console.log(`📅 Order ${order.id}: postponedTime = "${order.postponedTime}"`);

          // Check if it's ISO format (with T)
          if (order.postponedTime.includes("T")) {
            postponedDate = new Date(order.postponedTime);
            console.log(`   Format: ISO (${order.postponedTime})`);
          }
          // Check if it's DD.MM.YYYY format (with dots)
          else if (order.postponedTime.includes(".")) {
            const parts = order.postponedTime.split(".");
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            postponedDate = new Date(year, month, day);
            console.log(`   Format: DD.MM.YYYY -> Parsed as: ${day}-${month + 1}-${year}`);
          }
          // Otherwise it's DD/MM/YYYY format (with slashes)
          else {
            const parts = order.postponedTime.split("/");
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            postponedDate = new Date(year, month, day);
            console.log(`   Format: DD/MM/YYYY -> Parsed as: ${day}-${month + 1}-${year}`);
          }

          postponedDate.setHours(0, 0, 0, 0);

          const shouldShow = postponedDate <= today;
          console.log(`   Parsed date: ${postponedDate} | Today: ${today} | Show: ${shouldShow}`);

          return shouldShow;
        } catch (e) {
          console.error(`❌ Order ${order.id}: Error parsing date "${order.postponedTime}"`, e);
          return false;
        }
      }

      // Show all other statuses
      console.log(`✅ Order ${order.id} (${order.status}): SHOW - other status`);
      return true;
    });

    console.log(`\n📊 FILTERING RESULT: ${filtered.length} orders to show`);
    console.log(
      "Filtered orders IDs:",
      filtered.map((o: IOrder) => o.id),
    );
    console.log("=== END FILTERING ===\n");

    return filtered;
  }, [freeOrders]);

  const {
    handleChooseJob,
    availableJobs,
    showMaps,
    onSelectOrders,
    moveOrders,
    cancelCurrentAction,
    confirmMoveOrders,
    confirmAddOrders,
    confirmRemoveOrders,
    deleteOrders,
    currentPreviewAction,
    setShowMaps,
    addOrders,
    selectedIdsToAdd,
    handleSelectOrdersToAdd,
    handleReorderJobOrders,
    loadingJobs,
    changePickupOrder,
  } = useConfigureJobs({
    selectedJobId: Number(jobId),
    configureJobDeliveryJob,
    changePickupPoistionDeliveryJob,
    allJobsIds: incompleteJobs ?? [],
    setSelectedOrdersDeliveryJob,
    moveOrdersDeliveryJob,
    addOrdersDeliveryJob,
    setPreviewOrdersDeliveryJob,
    fetchDeliveryJobs,
    resetConfigureJobDeliveryJob,
    removeOrdersDeliveryJob,
    fetchAdminOrders,
    getJobsByStatusAdminOrder,
    freeOrders, // ← Pass unfiltered to hook
    getOneDeliveryJob,
    getRoutesDeliveryJob,
    getPolylineDeliveryJob,
    mainJob: JobsToConfigure?.mainJob?.job,
    changeOrderPositionDeliveryJob,
  });

  const [searchFilter, setSearchFilter] = useState<string>("orderId");
  const [searchValue, setSearchValue] = useState<string>("");

  const ordersSearchStatuses = ["new", "postponed", "postponed_after_pickup"].join("&status=");

  const getSearchOrdersAPI = useCallback(
    async (value: string) => {
      const currentLimit = freeOrdersPagination?.itemsPerPage || 25;

      if (!value || !value.trim()) {
        fetchAdminOrders(
          {},
          {
            query: {
              withoutJobs: true,
              status: ordersSearchStatuses,
              canBeAssigned: true,
              page: 1,
              limit: currentLimit,
            },
          },
        );
        return;
      }

      fetchAdminOrders(
        {},
        {
          query: {
            [searchFilter]: value.trim(),
            withoutJobs: true,
            status: ordersSearchStatuses,
            canBeAssigned: true,
            page: 1,
            limit: currentLimit,
          },
        },
      );
    },
    [searchFilter, fetchAdminOrders, freeOrdersPagination],
  );

  const handleSearch = (value: string) => {
    setSearchValue(value);
    getSearchOrdersAPI(value);
  };

  const handleSearchOrders = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (searchFilter === "orderId" && value && !/^\d+$/.test(value)) {
      message.info("Order ID must be a number");
      return;
    }
    setSearchValue(value);
    if (!value) {
      getSearchOrdersAPI("");
    }
  };

  const selectSearchFilter = (
    <Select
      defaultValue="orderId"
      className="select-before"
      onChange={(value: string) => {
        setSearchFilter(value);
        if (searchValue) {
          setSearchValue("");
          fetchAdminOrders({ status: ALL_STATUSES.join("&status="), fetchAll: true });
        }
      }}
    >
      <Option value="orderId">
        <FormattedMessage id="tabPane.orderID" defaultMessage="Order ID" />
      </Option>
      <Option value="customerName">
        <FormattedMessage id="tabPane.customerName" defaultMessage="Customer Name" />
      </Option>
    </Select>
  );

  const searchOrders = (
    <>
      <Input
        addonBefore={selectSearchFilter}
        placeholder="Search"
        className="searchOrderInput"
        style={{ marginBottom: "10px", maxWidth: "250px" }}
        value={searchValue}
        onChange={(e) => handleSearchOrders(e)}
        allowClear
        onPressEnter={(e: any) => handleSearch(e.target.value)}
      />
    </>
  );

  return (
    <>
      <Spin tip={"Loading jobs updates ..."} spinning={loadingJobs}>
        <div className="jobs_wrapper">
          <Row>
            <Breadcrumb style={{ margin: "10px 15px 20px" }}>
              <Breadcrumb.Item>
                <Link to={`/${BASE_ROUTE}/jobs`}>Job Management</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Configure Jobs</Breadcrumb.Item>
            </Breadcrumb>
          </Row>
          <Row>
            <Col lg={12} sm={24} className="jobs_wrapper--main">
              {JobsToConfigure && (
                <SingleJobHandler
                  isMain={true}
                  setShowMaps={setShowMaps}
                  jobToConfigure={JobsToConfigure.mainJob}
                  showMaps={showMaps}
                  availableJobs={availableJobs}
                  currentTenant={(currentTenant as keyof typeof mapCenters) ?? "Qatar"}
                  currentPreviewAction={currentPreviewAction}
                  cancelCurrentAction={cancelCurrentAction}
                  confirmMoveOrders={confirmMoveOrders}
                  confirmAddOrders={confirmAddOrders}
                  confirmRemoveOrders={confirmRemoveOrders}
                  deleteOrders={deleteOrders}
                  destinationJob={JobsToConfigure.compareToJob?.job?.id}
                  onSelectOrders={onSelectOrders}
                  moveOrders={moveOrders}
                  addOrders={addOrders}
                  freeOrders={freeOrders}
                  handleReorderJobOrders={handleReorderJobOrders}
                  changePickupOrder={changePickupOrder}
                />
              )}
            </Col>

            <Col lg={12} sm={24} className="jobs_wrapper--compare">
              {currentPreviewAction.isOn && currentPreviewAction.type === "add" ? (
                <>
                  <CustomCard subtitle="Orders without jobs">
                    {searchOrders}
                    <OrdersTable
                      isOrdersWithoutJob={true}
                      isMain={false}
                      isActionPreview={true}
                      destinationJob={currentPreviewAction.jobId!}
                      JobInfo={{
                        previewOrdersToAdd: [],
                        selectedIds: selectedIdsToAdd,
                        job: {
                          id: 0,
                          deliveryOrders: filteredFreeOrders, // ← USE FILTERED HERE!
                          jobRoutes: [],
                          status: "",
                        },
                      }}
                      onSelectOrders={handleSelectOrdersToAdd}
                      handleReorderJobOrders={handleReorderJobOrders}
                      deleteOrders={deleteOrders}
                      moveOrders={moveOrders}
                      addOrders={addOrders}
                      pagination={freeOrdersPagination}
                    />
                  </CustomCard>
                </>
              ) : (
                JobsToConfigure && (
                  <SingleJobHandler
                    isMain={false}
                    allJobsIds={incompleteJobs}
                    handleChooseJob={handleChooseJob}
                    jobToConfigure={JobsToConfigure.compareToJob}
                    showMaps={showMaps}
                    availableJobs={availableJobs}
                    currentTenant={(currentTenant as keyof typeof mapCenters) ?? "Qatar"}
                    currentPreviewAction={currentPreviewAction}
                    cancelCurrentAction={cancelCurrentAction}
                    confirmMoveOrders={confirmMoveOrders}
                    destinationJob={JobsToConfigure.mainJob?.job?.id}
                    onSelectOrders={onSelectOrders}
                    confirmAddOrders={confirmAddOrders}
                    confirmRemoveOrders={confirmRemoveOrders}
                    moveOrders={moveOrders}
                    addOrders={addOrders}
                    deleteOrders={deleteOrders}
                    handleReorderJobOrders={handleReorderJobOrders}
                    changePickupOrder={changePickupOrder}
                  />
                )
              )}
            </Col>
          </Row>
        </div>
      </Spin>
      <Footer className="footer" hidden={!currentPreviewAction.isOn}>
        <PreviewOrdersAtion
          currentPreviewAction={currentPreviewAction}
          cancelCurrentAction={cancelCurrentAction}
          confirmMoveOrders={confirmMoveOrders}
          confirmAddOrders={confirmAddOrders}
          confirmRemoveOrders={confirmRemoveOrders}
          freeOrders={filteredFreeOrders} // ← USE FILTERED HERE!
        />
      </Footer>
    </>
  );
};
const MSTP = (state: RootState) => {
  const jobIds = userRole === "retailer" ? state.retailerOrders.jobIds : state.adminOrders.jobIds;

  return userRole === "retailer"
    ? {
        deliveryJobs: state.retailerJob.items,
        isFetchingDeliveryJobs: state.retailerJob.isFetching,
        isMobile: state.admin.isMobile,
        freeOrders: state.retailerOrders?.items[0]?.items,
        freeOrdersPagination: state.retailerOrders?.items[0]?.meta,
        incompleteJobs: jobIds,
        forceBackToMainPage: state.retailerJob.forceBackToMainPage,
      }
    : {
        deliveryJobs: state.deliveryJobs.items,
        isFetchingDeliveryJobs: state.deliveryJobs.isFetching,
        isMobile: state.admin.isMobile,
        freeOrders: state.adminOrders?.items[0]?.items,
        freeOrdersPagination: state.adminOrders?.items[0]?.meta,
        incompleteJobs: jobIds,
        forceBackToMainPage: state.deliveryJobs.forceBackToMainPage,
      };
};

export default connect(MSTP, (dispatch) => {
  const {
    fetchDeliveryJobs,
    getOneDeliveryJob,
    getPolylineDeliveryJob,
    getRoutesDeliveryJob,
    addOrdersDeliveryJob,
    removeOrdersDeliveryJob,
    moveOrdersDeliveryJob,
    configureJobDeliveryJob,
    setSelectedOrdersDeliveryJob,
    setPreviewOrdersDeliveryJob,
    resetConfigureJobDeliveryJob,
    changeOrderPositionDeliveryJob,
    changePickupPoistionDeliveryJob,
    resetFlagDeliveryJob,
  } = bindActionCreators(deliveryJobActions, dispatch);

  const {
    fetchRetailerJobs,
    getOneRetailerJob,
    getPolylineRetailerJob,
    getRoutesRetailerJob,
    addOrdersRetailerJob,
    removeOrdersRetailerJob,
    moveOrdersRetailerJob,
    configureJobRetailerJob,
    setSelectedOrdersRetailerJob,
    setPreviewOrdersRetailerJob,
    resetConfigureJobRetailerJob,
    changeOrderPositionRetailerJob,
    changePickupPoistionRetailerJob,
    resetFlagRetailerJob,
    getJobsByStatusRetailerJob,
  } = bindActionCreators(retailerJobActions, dispatch);

  const { fetchAdminOrders, getJobsByStatusAdminOrder } = bindActionCreators(adminOrdersActions, dispatch);
  const { fetchRetailerOrders } = bindActionCreators(retailerOrdersActions, dispatch);

  return userRole === "retailer"
    ? {
        fetchDeliveryJobs: fetchRetailerJobs,
        getOneDeliveryJob: getOneRetailerJob,
        getPolylineDeliveryJob: getPolylineRetailerJob,
        getRoutesDeliveryJob: getRoutesRetailerJob,
        addOrdersDeliveryJob: addOrdersRetailerJob,
        removeOrdersDeliveryJob: removeOrdersRetailerJob,
        moveOrdersDeliveryJob: moveOrdersRetailerJob,
        configureJobDeliveryJob: configureJobRetailerJob,
        setSelectedOrdersDeliveryJob: setSelectedOrdersRetailerJob,
        setPreviewOrdersDeliveryJob: setPreviewOrdersRetailerJob,
        resetConfigureJobDeliveryJob: resetConfigureJobRetailerJob,
        changeOrderPositionDeliveryJob: changeOrderPositionRetailerJob,
        changePickupPoistionDeliveryJob: changePickupPoistionRetailerJob,
        resetFlagDeliveryJob: resetFlagRetailerJob,
        fetchAdminOrders: fetchRetailerOrders,
        getJobsByStatusAdminOrder: getJobsByStatusRetailerJob,
      }
    : {
        // Admin Job
        fetchDeliveryJobs,
        getOneDeliveryJob,
        getPolylineDeliveryJob,
        getRoutesDeliveryJob,
        addOrdersDeliveryJob,
        removeOrdersDeliveryJob,
        moveOrdersDeliveryJob,
        configureJobDeliveryJob,
        setSelectedOrdersDeliveryJob,
        setPreviewOrdersDeliveryJob,
        resetConfigureJobDeliveryJob,
        changeOrderPositionDeliveryJob,
        changePickupPoistionDeliveryJob,
        resetFlagDeliveryJob,
        fetchAdminOrders,
        getJobsByStatusAdminOrder,
      };
})(JobsConfigurePage);
// import { Breadcrumb, Col, Row, Spin } from "antd";
// import React, { FC, useEffect } from "react";
// import { useSelector, connect } from "react-redux";
// import { bindActionCreators } from "redux";
// import { mapCenters } from "../../constants/config";
// import { getUserTenant, userRole } from "../../helpers/authStorage";
// import { RootState } from "../../redux";
// import { OrdersTable } from "./components/OrdersTable";
// import useConfigureJobs from "./hooks/useConfigureJobs";
// import { IConfigureModalInput } from "./types/configureModal.types";

// import { actions as deliveryJobActions } from "../../redux/resources/deliveryJobs";
// import { actions as adminOrdersActions } from "../../redux/resources/adminOrders";

// import { actions as retailerJobActions } from "../../redux/resources/retailerJob";
// import { actions as retailerOrdersActions } from "../../redux/resources/retailerOrders";

// import { Link, useHistory, useParams } from "react-router-dom";
// import { CustomCard } from "../../utils/common";
// import "./styles/configureJobsModal.less";
// import SingleJobHandler from "./components/SingleJobHandler";
// import { Footer } from "antd/lib/layout/layout";
// import PreviewOrdersAtion from "./components/PreviewOrdersAction";
// import { IOrder } from "src/entities";
// import { BASE_ROUTE } from "src/routes";

// const JOB_MANAGEMENT_URL = userRole === "retailer" ? "/retailer_cabinet/jobs" : "/admin/jobs";

// const JobsConfigurePage: FC<IConfigureModalInput & any> = ({
//   // setConfigureModalOptions,
//   freeOrders,
//   getJobsByStatusAdminOrder,
//   freeOrdersPagination,

//   // actions
//   fetchDeliveryJobs,
//   getOneDeliveryJob,
//   getPolylineDeliveryJob,
//   getRoutesDeliveryJob,
//   fetchAdminOrders,
//   addOrdersDeliveryJob,
//   removeOrdersDeliveryJob,
//   moveOrdersDeliveryJob,
//   configureJobDeliveryJob,
//   setSelectedOrdersDeliveryJob,
//   setPreviewOrdersDeliveryJob,
//   resetConfigureJobDeliveryJob,
//   changeOrderPositionDeliveryJob,
//   changePickupPoistionDeliveryJob,
//   resetFlagDeliveryJob,
//   incompleteJobs,
// }) => {
//   const { id: jobId } = useParams<{ id?: string }>();
//   const history = useHistory();
//   const currentTenant = getUserTenant();

//   const JobsToConfigure: {
//     mainJob: {
//       job: any;
//       previewOrdersToAdd: IOrder[];
//       selectedIds: number[];
//     }; //TODO add type job
//     compareToJob: {
//       job: any;
//       previewOrdersToAdd: IOrder[];
//       selectedIds: number[];
//     }; //TODO add type job
//   } = useSelector((state: RootState) => {
//     return userRole === "retailer" ? state?.retailerJob?.jobsToConfigure : state?.deliveryJobs?.jobsToConfigure;
//   });

//   const {
//     handleChooseJob,
//     availableJobs,
//     showMaps,
//     onSelectOrders,
//     moveOrders,
//     cancelCurrentAction,
//     confirmMoveOrders,
//     confirmAddOrders,
//     confirmRemoveOrders,
//     deleteOrders,
//     currentPreviewAction,
//     setShowMaps,
//     addOrders,
//     selectedIdsToAdd,
//     handleSelectOrdersToAdd,
//     handleReorderJobOrders,
//     loadingJobs,
//     changePickupOrder,
//   } = useConfigureJobs({
//     selectedJobId: Number(jobId),
//     configureJobDeliveryJob,
//     changePickupPoistionDeliveryJob,
//     allJobsIds: incompleteJobs ?? [],
//     setSelectedOrdersDeliveryJob,
//     moveOrdersDeliveryJob,
//     addOrdersDeliveryJob,
//     setPreviewOrdersDeliveryJob,
//     fetchDeliveryJobs,
//     resetConfigureJobDeliveryJob,
//     removeOrdersDeliveryJob,
//     fetchAdminOrders,
//     getJobsByStatusAdminOrder,
//     freeOrders,
//     getOneDeliveryJob,
//     getRoutesDeliveryJob,
//     getPolylineDeliveryJob,
//     mainJob: JobsToConfigure?.mainJob?.job,
//     changeOrderPositionDeliveryJob,
//   });

//   return (
//     <>
//       <Spin tip={"Loading jobs updates ..."} spinning={loadingJobs}>
//         <div className="jobs_wrapper">
//           <Row>
//             <Breadcrumb style={{ margin: "10px 15px 20px" }}>
//               <Breadcrumb.Item>
//                 <Link to={`/${BASE_ROUTE}/jobs`}>Job Management</Link>
//               </Breadcrumb.Item>
//               <Breadcrumb.Item>Configure Jobs</Breadcrumb.Item>
//             </Breadcrumb>
//           </Row>
//           <Row>
//             <Col lg={12} sm={24} className="jobs_wrapper--main">
//               {JobsToConfigure && (
//                 <SingleJobHandler
//                   isMain={true}
//                   setShowMaps={setShowMaps}
//                   jobToConfigure={JobsToConfigure.mainJob}
//                   showMaps={showMaps}
//                   availableJobs={availableJobs}
//                   currentTenant={(currentTenant as keyof typeof mapCenters) ?? "Qatar"}
//                   currentPreviewAction={currentPreviewAction}
//                   cancelCurrentAction={cancelCurrentAction}
//                   confirmMoveOrders={confirmMoveOrders}
//                   confirmAddOrders={confirmAddOrders}
//                   confirmRemoveOrders={confirmRemoveOrders}
//                   deleteOrders={deleteOrders}
//                   destinationJob={JobsToConfigure.compareToJob?.job?.id}
//                   onSelectOrders={onSelectOrders}
//                   moveOrders={moveOrders}
//                   addOrders={addOrders}
//                   freeOrders={freeOrders}
//                   handleReorderJobOrders={handleReorderJobOrders}
//                   changePickupOrder={changePickupOrder}
//                 />
//               )}
//             </Col>

//             <Col lg={12} sm={24} className="jobs_wrapper--compare">
//               {currentPreviewAction.isOn && currentPreviewAction.type === "add" ? (
//                 <CustomCard subtitle="Orders without jobs">
//                   <OrdersTable
//                     isOrdersWithoutJob={true}
//                     isMain={false}
//                     isActionPreview={true}
//                     destinationJob={currentPreviewAction.jobId!}
//                     JobInfo={{
//                       previewOrdersToAdd: [],
//                       selectedIds: selectedIdsToAdd,
//                       job: {
//                         id: 0,
//                         deliveryOrders: freeOrders,
//                         jobRoutes: [],
//                         status: "",
//                       },
//                     }}
//                     onSelectOrders={handleSelectOrdersToAdd}
//                     handleReorderJobOrders={handleReorderJobOrders}
//                     deleteOrders={deleteOrders}
//                     moveOrders={moveOrders}
//                     addOrders={addOrders}
//                     pagination={freeOrdersPagination}
//                   />
//                 </CustomCard>
//               ) : (
//                 JobsToConfigure && (
//                   <SingleJobHandler
//                     isMain={false}
//                     allJobsIds={incompleteJobs}
//                     handleChooseJob={handleChooseJob}
//                     jobToConfigure={JobsToConfigure.compareToJob}
//                     showMaps={showMaps}
//                     availableJobs={availableJobs}
//                     currentTenant={(currentTenant as keyof typeof mapCenters) ?? "Qatar"}
//                     currentPreviewAction={currentPreviewAction}
//                     cancelCurrentAction={cancelCurrentAction}
//                     confirmMoveOrders={confirmMoveOrders}
//                     destinationJob={JobsToConfigure.mainJob?.job?.id}
//                     onSelectOrders={onSelectOrders}
//                     confirmAddOrders={confirmAddOrders}
//                     confirmRemoveOrders={confirmRemoveOrders}
//                     moveOrders={moveOrders}
//                     addOrders={addOrders}
//                     deleteOrders={deleteOrders}
//                     handleReorderJobOrders={handleReorderJobOrders}
//                     changePickupOrder={changePickupOrder}
//                   />
//                 )
//               )}
//             </Col>
//           </Row>
//         </div>
//       </Spin>
//       <Footer className="footer" hidden={!currentPreviewAction.isOn}>
//         <PreviewOrdersAtion
//           currentPreviewAction={currentPreviewAction}
//           cancelCurrentAction={cancelCurrentAction}
//           confirmMoveOrders={confirmMoveOrders}
//           confirmAddOrders={confirmAddOrders}
//           confirmRemoveOrders={confirmRemoveOrders}
//           freeOrders={freeOrders}
//         />
//       </Footer>
//     </>
//   );
// };
// const MSTP = (state: RootState) => {
//   const jobIds = userRole === "retailer" ? state.retailerOrders.jobIds : state.adminOrders.jobIds;

//   return userRole === "retailer"
//     ? {
//         deliveryJobs: state.retailerJob.items,
//         isFetchingDeliveryJobs: state.retailerJob.isFetching,
//         isMobile: state.admin.isMobile,
//         freeOrders: state.retailerOrders?.items[0]?.items,
//         freeOrdersPagination: state.retailerOrders?.items[0]?.meta,
//         incompleteJobs: jobIds,
//         forceBackToMainPage: state.retailerJob.forceBackToMainPage,
//       }
//     : {
//         deliveryJobs: state.deliveryJobs.items,
//         isFetchingDeliveryJobs: state.deliveryJobs.isFetching,
//         isMobile: state.admin.isMobile,
//         freeOrders: state.adminOrders?.items[0]?.items,
//         freeOrdersPagination: state.adminOrders?.items[0]?.meta,
//         incompleteJobs: jobIds,
//         forceBackToMainPage: state.deliveryJobs.forceBackToMainPage,
//       };
// };

// export default connect(MSTP, (dispatch) => {
//   const {
//     fetchDeliveryJobs,
//     getOneDeliveryJob,
//     getPolylineDeliveryJob,
//     getRoutesDeliveryJob,
//     addOrdersDeliveryJob,
//     removeOrdersDeliveryJob,
//     moveOrdersDeliveryJob,
//     configureJobDeliveryJob,
//     setSelectedOrdersDeliveryJob,
//     setPreviewOrdersDeliveryJob,
//     resetConfigureJobDeliveryJob,
//     changeOrderPositionDeliveryJob,
//     changePickupPoistionDeliveryJob,
//     resetFlagDeliveryJob,
//   } = bindActionCreators(deliveryJobActions, dispatch);

//   const {
//     fetchRetailerJobs,
//     getOneRetailerJob,
//     getPolylineRetailerJob,
//     getRoutesRetailerJob,
//     addOrdersRetailerJob,
//     removeOrdersRetailerJob,
//     moveOrdersRetailerJob,
//     configureJobRetailerJob,
//     setSelectedOrdersRetailerJob,
//     setPreviewOrdersRetailerJob,
//     resetConfigureJobRetailerJob,
//     changeOrderPositionRetailerJob,
//     changePickupPoistionRetailerJob,
//     resetFlagRetailerJob,
//     getJobsByStatusRetailerJob,
//   } = bindActionCreators(retailerJobActions, dispatch);

//   const { fetchAdminOrders, getJobsByStatusAdminOrder } = bindActionCreators(adminOrdersActions, dispatch);
//   const { fetchRetailerOrders } = bindActionCreators(retailerOrdersActions, dispatch);

//   return userRole === "retailer"
//     ? {
//         fetchDeliveryJobs: fetchRetailerJobs,
//         getOneDeliveryJob: getOneRetailerJob,
//         getPolylineDeliveryJob: getPolylineRetailerJob,
//         getRoutesDeliveryJob: getRoutesRetailerJob,
//         addOrdersDeliveryJob: addOrdersRetailerJob,
//         removeOrdersDeliveryJob: removeOrdersRetailerJob,
//         moveOrdersDeliveryJob: moveOrdersRetailerJob,
//         configureJobDeliveryJob: configureJobRetailerJob,
//         setSelectedOrdersDeliveryJob: setSelectedOrdersRetailerJob,
//         setPreviewOrdersDeliveryJob: setPreviewOrdersRetailerJob,
//         resetConfigureJobDeliveryJob: resetConfigureJobRetailerJob,
//         changeOrderPositionDeliveryJob: changeOrderPositionRetailerJob,
//         changePickupPoistionDeliveryJob: changePickupPoistionRetailerJob,
//         resetFlagDeliveryJob: resetFlagRetailerJob,
//         fetchAdminOrders: fetchRetailerOrders,
//         getJobsByStatusAdminOrder: getJobsByStatusRetailerJob,
//       }
//     : {
//         // Admin Job
//         fetchDeliveryJobs,
//         getOneDeliveryJob,
//         getPolylineDeliveryJob,
//         getRoutesDeliveryJob,
//         addOrdersDeliveryJob,
//         removeOrdersDeliveryJob,
//         moveOrdersDeliveryJob,
//         configureJobDeliveryJob,
//         setSelectedOrdersDeliveryJob,
//         setPreviewOrdersDeliveryJob,
//         resetConfigureJobDeliveryJob,
//         changeOrderPositionDeliveryJob,
//         changePickupPoistionDeliveryJob,
//         resetFlagDeliveryJob,
//         fetchAdminOrders,
//         getJobsByStatusAdminOrder,
//       };
// })(JobsConfigurePage);
